<template>
<div class="chapter">
<div class="inner_page">
<p class="toch">CONTENTS</p>
<p class="toc1"><a href="#/Text/prologue">PROLOGUE</a></p>
<p class="toc1"><a href="#/Text/Section0001">1</a></p>
<p class="toc1"><a href="#/Text/Section0002">2</a></p>
<p class="toc1"><a href="#/Text/Section0003">3</a></p>
<p class="toc1"><a href="#/Text/Section0004">4</a></p>
<p class="toc1"><a href="#/Text/Section0005">5</a></p>
<p class="toc1"><a href="#/Text/Section0006">6</a></p>
<p class="toc1"><a href="#/Text/Section0007">7</a></p>
<p class="toc1"><span href="#/Text/Section0008" title="Link target outside of Sample">8</span></p>
<p class="toc1"><span href="#/Text/Section0009" title="Link target outside of Sample">9</span></p>
<p class="toc1"><span href="#/Text/Section0010" title="Link target outside of Sample">10</span></p>
<p class="toc1"><span href="#/Text/Section0011" title="Link target outside of Sample">11</span></p>
<p class="toc1"><span href="#/Text/Section0012" title="Link target outside of Sample">12</span></p>
<p class="toc1"><span href="#/Text/Section0013" title="Link target outside of Sample">13</span></p>
<p class="toc1"><span href="#/Text/Section0014" title="Link target outside of Sample">14</span></p>
<p class="toc1"><span href="#/Text/Section0015" title="Link target outside of Sample">15</span></p>
<p class="toc1"><span href="#/Text/Section0016" title="Link target outside of Sample">16</span></p>
<p class="toc1"><span href="#/Text/Section0017" title="Link target outside of Sample">17</span></p>
<p class="toc1"><span href="#/Text/Section0018" title="Link target outside of Sample">18</span></p>
<p class="toc1"><span href="#/Text/Section0019" title="Link target outside of Sample">19</span></p>
<p class="toc1"><span href="#/Text/Section0020" title="Link target outside of Sample">20</span></p>
<p class="toc1"><span href="#/Text/Section0021" title="Link target outside of Sample">21</span></p>
<p class="toc1"><span href="#/Text/Section0022" title="Link target outside of Sample">22</span></p>
<p class="toc1"><span href="#/Text/Section0023" title="Link target outside of Sample">23</span></p>
<p class="toc1"><span href="#/Text/Section0024" title="Link target outside of Sample">24</span></p>
<p class="toc1"><span href="#/Text/Section0025" title="Link target outside of Sample">25</span></p>
<p class="toc1"><span href="#/Text/Section0026" title="Link target outside of Sample">26</span></p>
<p class="toc1"><span href="#/Text/Section0027" title="Link target outside of Sample">27</span></p>
<p class="toc1"><span href="#/Text/Section0028" title="Link target outside of Sample">28</span></p>
<p class="toc1"><span href="#/Text/Section0029" title="Link target outside of Sample">29</span></p>
<p class="toc1"><span href="#/Text/Section0030" title="Link target outside of Sample">30</span></p>
<p class="toc1"><span href="#/Text/Section0031" title="Link target outside of Sample">31</span></p>
<p class="toc1"><span href="#/Text/Section0032" title="Link target outside of Sample">32</span></p>
<p class="toc1"><span href="#/Text/Section0033" title="Link target outside of Sample">33</span></p>
<p class="toc1"><span href="#/Text/Section0034" title="Link target outside of Sample">34</span></p>
<p class="toc1"><span href="#/Text/Section0035" title="Link target outside of Sample">35</span></p>
<p class="toc1"><span href="#/Text/Section0036" title="Link target outside of Sample">36</span></p>
<p class="toc1"><span href="#/Text/Section0037" title="Link target outside of Sample">37</span></p>
<p class="toc1"><span href="#/Text/Section0038" title="Link target outside of Sample">38</span></p>
<p class="toc1"><span href="#/Text/Section0039" title="Link target outside of Sample">39</span></p>
<p class="toc1"><span href="#/Text/Section0040" title="Link target outside of Sample">40</span></p>
<p class="toc1"><span href="#/Text/Section0041" title="Link target outside of Sample">41</span></p>
<p class="toc1"><span href="#/Text/Section0042" title="Link target outside of Sample">42</span></p>
<p class="toc1"><span href="#/Text/Section0043" title="Link target outside of Sample">43</span></p>
<p class="toc1"><span href="#/Text/Section0044" title="Link target outside of Sample">44</span></p>
<p class="toc1"><span href="#/Text/Section0045" title="Link target outside of Sample">45</span></p>
<p class="toc1"><span href="#/Text/Section0046" title="Link target outside of Sample">46</span></p>
<p class="toc1"><span href="#/Text/Section0047" title="Link target outside of Sample">47</span></p>
<p class="toc1"><span href="#/Text/Section0048" title="Link target outside of Sample">48</span></p>
<p class="toc1"><span href="#/Text/Section0049" title="Link target outside of Sample">49</span></p>
<p class="toc1"><span href="#/Text/Section0050" title="Link target outside of Sample">50</span></p>
<p class="toc1"><span href="#/Text/Section0051" title="Link target outside of Sample">51</span></p>
<p class="toc1"><span href="#/Text/Section0052" title="Link target outside of Sample">52</span></p>
<p class="toc1"><span href="#/Text/Section0053" title="Link target outside of Sample">53</span></p>
<p class="toc1"><span href="#/Text/Section0054" title="Link target outside of Sample">54</span></p>
<p class="toc1"><span href="#/Text/Section0055" title="Link target outside of Sample">55</span></p>
<p class="toc1"><span href="#/Text/Section0056" title="Link target outside of Sample">56</span></p>
<p class="toc1"><span href="#/Text/Section0057" title="Link target outside of Sample">57</span></p>
<p class="toc1"><span href="#/Text/Section0058" title="Link target outside of Sample">58</span></p>
<p class="toc1"><span href="#/Text/Section0059" title="Link target outside of Sample">59</span></p>
<p class="toc1"><span href="#/Text/Section0060" title="Link target outside of Sample">60</span></p>
<p class="toc1"><span href="#/Text/Section0061" title="Link target outside of Sample">61</span></p>
<p class="toc1"><span href="#/Text/Section0062" title="Link target outside of Sample">62</span></p>
<p class="toc1"><span href="#/Text/Section0063" title="Link target outside of Sample">63</span></p>
<p class="toc1"><span href="#/Text/Section0064" title="Link target outside of Sample">64</span></p>
<p class="toc1"><span href="#/Text/Section0065" title="Link target outside of Sample">65</span></p>
<p class="toc1"><span href="#/Text/Section0066" title="Link target outside of Sample">66</span></p>
<p class="toc1"><span href="#/Text/Section0067" title="Link target outside of Sample">67</span></p>
<p class="toc1"><span href="#/Text/Section0068" title="Link target outside of Sample">68</span></p>
<p class="toc1"><span href="#/Text/Section0069" title="Link target outside of Sample">69</span></p>
<p class="toc1"><span href="#/Text/Section0070" title="Link target outside of Sample">70</span></p>
<p class="toc1"><span href="#/Text/Section0071" title="Link target outside of Sample">71</span></p>
<p class="toc1"><span href="#/Text/Section0072" title="Link target outside of Sample">72</span></p>
<p class="toc1"><span href="#/Text/Section0073" title="Link target outside of Sample">73</span></p>
<p class="toc1"><span href="#/Text/Section0074" title="Link target outside of Sample">74</span></p>
<p class="toc1"><span href="#/Text/Section0075" title="Link target outside of Sample">75</span></p>
<p class="toc1"><span href="#/Text/Section0076" title="Link target outside of Sample">76</span></p>
<p class="toc1"><span href="#/Text/Section0077" title="Link target outside of Sample">77</span></p>
<p class="toc1"><span href="#/Text/Section0078" title="Link target outside of Sample">78</span></p>
<p class="toc1"><span href="#/Text/Section0079" title="Link target outside of Sample">79</span></p>
<p class="toc1"><span href="#/Text/Section0080" title="Link target outside of Sample">80</span></p>
<p class="toc1"><span href="#/Text/Section0081" title="Link target outside of Sample">81</span></p>
<p class="toc2"><span href="#/Text/authornote" title="Link target outside of Sample">AUTHOR’S NOTE</span></p>
<p class="toc1"><span href="#/Text/acknowledgments" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="toc1"><span href="#/Text/aboutauthor" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7cf4beea